import React from "react";
import { Row, Col } from "react-bootstrap";
import ServiceCard from "./ServiceCard";

import services from "../data/Services.json";
import "./services.css";

export default function Services() {
  return (
    <div className="d-flex flex-row" id="services" data-aos="fade-up">
      <div className="flex-column services-img-container">
        <img
          src={"./images/gardening-portrait.jpg"}
          alt={"Plant with Hand"}
          className="m-5"
          style={{
            borderRadius: "10px",
            width: "90%",
            height: "90%",
            objectFit: "cover",
          }}
        />
      </div>
      <div className="d-flex flex-grow-1 justify-content-start align-items-start flex-column services-content-container">
        <Row className="m-5 d-flex justify-content-center align-items-center">
          <div
            className="p-0 fs-4 text-uppercase"
            style={{ color: "var(--primary)" }}
          >
            Services
          </div>
          <div className="p-0 fs-1 fw-bold">What services we offer</div>
          <div>
            <hr
              style={{
                width: "10%",
                borderTop: "6px solid var(--primary)",
                opacity: "1",
                borderRadius: "10px",
              }}
            />
          </div>

          <Row
            sm={1}
            md={2}
            xl={3}
            className="g-4 d-flex justify-content-center align-items-center"
          >
            {services?.map((service, index) => (
              <Col key={index}>
                <ServiceCard service={service} />
              </Col>
            ))}
          </Row>
        </Row>
      </div>
    </div>
  );
}
